import * as React from 'react';
import OriginalSelect, { Props as SelectProps, GroupBase } from 'react-select';
import OriginalAsyncSelect, {
  AsyncProps as AsyncSelectProps,
} from 'react-select/async';
import i18n from '@/i18n';

function createSelect<
  Option,
  IsMulti extends boolean = boolean,
  Group extends GroupBase<Option> = GroupBase<Option>,
>() {
  return React.forwardRef<any, SelectProps<Option, IsMulti, Group>>(
    (
      { classNamePrefix = 'react-select', menuPlacement = 'auto', blurInputOnSelect = true, ...props },
      ref,
    ) => (
      <OriginalSelect<Option, IsMulti, Group>
        ref={ref}
        classNamePrefix={classNamePrefix}
        styles={{
          menu: (provided) => ({ ...provided, zIndex: 9999 }),
        }}
        noOptionsMessage={({ inputValue }) => i18n.t('common.no_options')}
        loadingMessage={() => i18n.t('common.loading')}
        placeholder={i18n.t('common.select')}
        menuPlacement={menuPlacement}
        blurInputOnSelect={blurInputOnSelect}
        {...props}
      />
    ),
  );
}

function createAsyncSelect<
  Option,
  IsMulti extends boolean = boolean,
  Group extends GroupBase<Option> = GroupBase<Option>,
>() {
  return React.forwardRef<any, AsyncSelectProps<Option, IsMulti, Group>>(
    (
      {
        classNamePrefix = 'react-select',
        menuPlacement = 'auto',
        cacheOptions = true,
        blurInputOnSelect = true,
        ...props
      },
      ref,
    ) => (
      <OriginalAsyncSelect<Option, IsMulti, Group>
        ref={ref}
        classNamePrefix={classNamePrefix}
        styles={{
          menu: (provided) => ({ ...provided, zIndex: 9999 }),
        }}
        noOptionsMessage={({ inputValue }) => i18n.t('common.no_options')}
        loadingMessage={() => i18n.t('common.loading')}
        placeholder={i18n.t('common.select')}
        menuPlacement={menuPlacement}
        cacheOptions={cacheOptions}
        blurInputOnSelect={blurInputOnSelect}
        {...props}
      />
    ),
  );
}

// fallback
const Select = createSelect<any>();
Select.displayName = 'Select';

const AsyncSelect = createAsyncSelect<any>();
AsyncSelect.displayName = 'AsyncSelect';

export { Select, AsyncSelect };
